import axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ReactSelect from "../../../Components/PortalSelect";
import { RevertBackSchema } from "../../../ValidationSchema";
import Modal from "../../../Components/Modal";

const RevertBackModal = ({ show, userId, order_assigned_id, onClose }) => {
  const Navigate = useNavigate();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [salesExecutiveData, setSalesExecutiveData] = useState([]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      border: "1px solid #bfc9d4",
      boxShadow: "#000 !important",
      borderRadius: "6px",
      padding: "4px",
      "&:hover": {
        border: "1px solid #bfc9d4",
      },
    }),
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#606060",
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#fff",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#000",
      "& > svg": {
        backgroundColor: "#fff",
        borderRadius: "10px",
        marginLeft: "2px",
        marginRight: "2px",
      },
      ":hover": {
        backgroundColor: data.color,
        color: data.color,
      },
    }),
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "white",
        color: "#000",
        ":hover": {
          backgroundColor: "#f5f5f5",
        },
      };
    },
  };

  const SalesExecutiveData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/sub-admin-sales-excutive`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setSalesExecutiveData(
          res?.data?.data?.map((item) => {
            return {
              label: item?.name || "Untitled", // fallback if title is undefined
              value: item?.id,
            };
          })
        );
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const [initialValues] = useState({
    remark: "",
    supplier_id: "",
  });

  const AddRevertBack = useFormik({
    initialValues,
    // validationSchema: RevertBackSchema,

    onSubmit: (values, action) => {
      let data = {
        remark: values.remark,
        price: values.price,
      };
      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/quotation/send/price/${order_assigned_id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            // Navigate("/admin/inbound", { state: res.data.msg });
            window.location.reload();
            onClose();
            action.resetForm();
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  React.useEffect(() => {
    SalesExecutiveData();
  }, []);

  return (
    <Modal
      open={!!show}
      onClose={onClose}
      title="Send Quotation"
      subtitle="Quote your price for this order."
      size="sm"
      footer={
        <>
          <button type="button" className="al-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="al-btn al-btn--primary"
            onClick={AddRevertBack.handleSubmit}
          >
            Send quotation
          </button>
        </>
      }
    >
      <div className="al-field">
        <label className="al-label">Price</label>
        <input
          className="al-input"
          type="text"
          placeholder="Enter price"
          value={AddRevertBack.values.price}
          onChange={AddRevertBack.handleChange}
          onBlur={AddRevertBack.handleBlur}
          name="price"
        />
        {AddRevertBack.errors.price && AddRevertBack.touched.price && (
          <span className="al-err">{AddRevertBack.errors.price}</span>
        )}
      </div>

      <div className="al-field">
        <label className="al-label">Remark</label>
        <textarea
          className="al-textarea"
          placeholder="Enter remark"
          value={AddRevertBack.values.remark}
          onChange={AddRevertBack.handleChange}
          onBlur={AddRevertBack.handleBlur}
          name="remark"
          rows="4"
        />
        {AddRevertBack.errors.remark && AddRevertBack.touched.remark && (
          <span className="al-err">{AddRevertBack.errors.remark}</span>
        )}
      </div>
    </Modal>
  );
};

export default RevertBackModal;
